// To do
export const logout = () => {
  localStorage.removeItem('userConfig');
  // window.location.reload();
};
